import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "my-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "ml-4 cursor-pointer font-weight-normal text-primary fs-16" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-left" }),
  /*#__PURE__*/_createTextVNode("  Back ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "ml-4 font-bold cursor-pointer fs-16" }, "Ticket Details", -1)
const _hoisted_4 = {
  key: 0,
  class: "mb-2 grid-content"
}
const _hoisted_5 = { class: "mb-0 font-bold" }
const _hoisted_6 = { class: "font-normal text-muted" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Created by ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Open")
const _hoisted_9 = { class: "mb-3 ConversationItem is-seller" }
const _hoisted_10 = { class: "Top" }
const _hoisted_11 = { class: "font-bold Subject text-primary" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "mx-1 Separator" }, "-", -1)
const _hoisted_13 = { class: "CreatedTime fs-14 text-muted" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "my-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("b", null, "Attachments:", -1)
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "dialog-footer" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-comments" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode("   Add Comment ")
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode("   Close ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_Editor = _resolveComponent("Editor")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (!_ctx.isLoading)
    ? (_openBlock(), _createBlock(_component_el_dialog, {
        key: 0,
        modelValue: _ctx.dialogVisible,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dialogVisible) = $event)),
        top: "2vh"
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_button, {
              type: "primary",
              link: "",
              onClick: _ctx.onClose
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["onClick"]),
            _hoisted_3
          ])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_18, [
            (_ctx.dataTicket.ticket.status !== 4)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addCommentTicket(_ctx.ruleFormRef))),
                  disabled: _ctx.isDisableAddContent,
                  loading: _ctx.dataTicket.isLoading
                }, {
                  default: _withCtx(() => [
                    _hoisted_19,
                    _hoisted_20
                  ]),
                  _: 1
                }, 8, ["disabled", "loading"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogVisible = false)),
              type: "primary"
            }, {
              default: _withCtx(() => [
                _hoisted_21,
                _hoisted_22
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 10 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                xs: 16,
                sm: 16,
                md: 20,
                lg: 22,
                xl: 22
              }, {
                default: _withCtx(() => [
                  (_ctx.dataTicket.ticket._id && _ctx.dataTicket.ticket._id !== '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.dataTicket.ticket.subject), 1),
                        _createElementVNode("div", _hoisted_6, [
                          _hoisted_7,
                          _createElementVNode("b", null, _toDisplayString(_ctx.dataTicket.ticket.requester), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 8,
                sm: 8,
                md: 4,
                lg: 2,
                xl: 2
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_tag, {
                    type: "info",
                    class: "mx-1",
                    effect: "dark",
                    round: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _withDirectives(_createVNode(_component_el_table, {
                data: _ctx.dataTicket.ticket.conversations,
                border: false,
                "row-class-name": _ctx.tableRowClassName
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    property: "subject",
                    label: "",
                    style: {"cursor":"pointer"}
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("span", _hoisted_11, _toDisplayString(scope.row.full_name ? scope.row.full_name : scope.row.email), 1),
                          _hoisted_12,
                          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.formatShortDateMonthTime(scope.row.updated_at)), 1)
                        ]),
                        _createElementVNode("div", {
                          class: "Description",
                          innerHTML: scope.row.body
                        }, null, 8, _hoisted_14)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data", "row-class-name"]), [
                [_directive_loading, _ctx.dataTicket.isLoading || _ctx.dataTicket.isLoading2]
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                (_ctx.dataTicket.ticket.attachments?.length > 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_17))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataTicket.ticket.attachments, (item, index) => {
                  return (_openBlock(), _createElementBlock("p", { key: index }, [
                    _createVNode(_component_el_button, {
                      type: "text",
                      onClick: ($event: any) => (_ctx.downloadFile(item)),
                      title: "Click to download file"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.getFileNameFromUrl(item)), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]))
                }), 128))
              ]),
              _createVNode(_component_el_form, {
                model: _ctx.dataTicket.ticket,
                ref: "ruleFormRef",
                class: "w-full font-bold",
                size: "default",
                "label-position": "top"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "",
                    prop: "body_text"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Editor, {
                        modelValue: _ctx.dataTicket.ticket.body_text,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dataTicket.ticket.body_text) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}